<template>
  <div>
    <el-dialog
      :title="dialogData.title"
      :visible.sync="dialogData.show"
      width="600px"
      center
    >
      <el-form inline :model="mFormData" label-width="100px">
        <el-form-item>
          <el-radio-group v-model="mRadio" @change="OnChangeLangRadio(false)">
            <div
              v-for="item in langs"
              :key="item.id"
              style="position: relative; display: inline-block; margin: 4px"
            >
              <el-radio-button :label="item.id">
                {{ item.name }}
                <!-- <span v-if="OnIsShowStar(item.id)">(必填)</span> -->
              </el-radio-button>
              <el-badge
                v-if="OnIsShowRedDot(item.id)"
                is-dot
                class="red-dot"
              ></el-badge>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="CustomeService" style="margin-bottom: 10px">
          <h4>
            <!-- <span style="color: red" v-if="OnIsShowStar()">*</span> -->
            {{ $t('OnlineCustomerServiceLink') }}
          </h4>
          <el-input
            clearable
            style="width: 550px"
            v-model="mFormData.CustomeService"
            :placeholder="$t('EnterOnlineCustomerServiceLink')"
            @input="OnInputLink('CustomeService')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="CustomSkype" style="margin-bottom: 10px">
          <h4>Skype{{$t('CustomerServiceLink')}}</h4>
          <el-input
            clearable
            style="width: 550px"
            v-model="mFormData.CustomSkype"
            :placeholder="$t('EnterSkypeCustomerServiceLink')"
            @input="OnInputLink('CustomSkype')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="CustomTelegram" style="margin-bottom: 10px">
          <h4>TG{{ $t('CustomerServiceLink') }}</h4>
          <el-input
            clearable
            style="width: 550px"
            v-model="mFormData.CustomTelegram"
            :placeholder="$t('EnterTGCustomerServiceLink')"
            @input="OnInputLink('CustomTelegram')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="CustomTelegramGroup" style="margin-bottom: 10px">
          <h4>{{$t('OfficialChannelLink')}}</h4>
          <el-input
            clearable
            style="width: 550px"
            v-model="mFormData.CustomTelegramGroup"
            :placeholder="$t('EnterOfficialChannelLink')"
            @input="OnInputLink('CustomTelegramGroup')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="CustomWhatapp" style="margin-bottom: 10px">
          <h4>WhatApp{{ $t('CustomerServiceLink') }}</h4>
          <el-input
            clearable
            style="width: 550px"
            v-model="mFormData.CustomWhatapp"
            :placeholder="$t('EnterWhatAppCustomerServiceLink')"
            @input="OnInputLink('CustomWhatapp')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="dialogData.show = false"
          >{{$t('Cancel')}}</el-button
        >
        <el-button size="medium" type="primary" @click="submitEditRow"
          >{{ $t('Confirm') }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
export default {
  extends: base,
  name: "InAgentEditCustomer",
  props: {
    dialogData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mRadio: 1,
      mFormData: {
        CustomeService: "",
        CustomSkype: "",
        CustomTelegram: "",
        CustomTelegramGroup: "",
        CustomWhatapp: "",
      },
      mLastRadio: 1,
      mLangsData: {},
      mRequiredLangs: {
        1: true,
        2: true,
      },
      mCheckArrs: {
        //CustomeService: { HeadMsg: "在线客服" },
        //CustomSkype: { HeadMsg: "Skype客服" },
        //CustomTelegram: { HeadMsg: "TG客服" },
        //CustomTelegramGroup: { HeadMsg: "官方频道" },
        //CustomWhatapp: { HeadMsg: "WhatsApp客服" },
      },
      mLangKey: {
        1: "",
        2: "en",
        3: "td",
        4: "ko",
        5: "tr",
        6: "vi",
        7: "pt",
        8: "hi",
        9: "ja",
        10: "ru",
        11: "km",
        12: "uk",
        13: "zh-TW",
        14: "es",
      },
    };
  },
  created() {
    if (this.dialogData.row.CustomeService) {
      let tJson = JSON.parse(this.dialogData.row.CustomeService);
      if (tJson) {
        for (let key in this.mLangKey) {
          for (let serviceKey in this.mFormData) {
            let strVal = tJson[serviceKey + this.mLangKey[key]];
            if (strVal) {
              this.mLangsData[key] = this.mLangsData[key] || {};
              this.mLangsData[key][serviceKey] = strVal;
            }
          }
        }
      }
    }
    this.OnChangeLangRadio(true);
  },
  methods: {
    OnInputLink(pKey) {
      this.mLangsData[this.mRadio][pKey] = this.mFormData[pKey];
      this.$forceUpdate();
    },
    OnIsShowStar(pLang) {
      return this.mRequiredLangs[pLang || this.mRadio];
    },
    OnIsShowRedDot(pLang) {
      let tItem = this.mLangsData[pLang];
      if (
        tItem &&
        (tItem.CustomeService ||
          tItem.CustomSkype ||
          tItem.CustomTelegram ||
          tItem.CustomTelegramGroup ||
          tItem.CustomWhatapp)
      ) {
        return true;
      }
      return false;
    },
    OnCheckFormDataInput(pLang, pOnlyFormat) {
      let bPass = true;
      let tItem = this.mLangsData[pLang] || {};
      let strLangName = this.langmap[pLang] || "";
      for (const pKey in this.mCheckArrs) {
        // tItem[pKey] = this.OnChangeUrl(tItem[pKey] || "");
        // if (this.mRadio == pLang) {
        //   this.mFormData[pKey] = tItem[pKey];
        // }
        if (
          !this.OnCheckUrl(
            tItem[pKey],
            strLangName + this.mCheckArrs[pKey].HeadMsg,
            pOnlyFormat
          )
        ) {
          bPass = false;
          break;
        }
      }
      return bPass;
    },
    OnChangeLangRadio(pInit) {
      // if (!pInit && !this.OnCheckFormDataInput(this.mLastRadio)) {
      //   this.mRadio = this.mLastRadio;
      //   return;
      // }
      this.mLastRadio = this.mRadio;

      if (!this.mLangsData[this.mRadio]) {
        this.mLangsData[this.mRadio] = {
          CustomeService: this.mFormData.CustomeService,
          CustomSkype: this.mFormData.CustomSkype,
          CustomTelegram: this.mFormData.CustomTelegram,
          CustomTelegramGroup: this.mFormData.CustomTelegramGroup,
          CustomWhatapp: this.mFormData.CustomWhatapp,
        };
      } else {
        this.mFormData = this.mLangsData[this.mRadio];
        this.mFormData.CustomeService = this.mFormData.CustomeService || "";
        this.mFormData.CustomSkype = this.mFormData.CustomSkype || "";
        this.mFormData.CustomTelegram = this.mFormData.CustomTelegram || "";
        this.mFormData.CustomTelegramGroup =
          this.mFormData.CustomTelegramGroup || "";
        this.mFormData.CustomWhatapp = this.mFormData.CustomWhatapp || "";
      }
    },
    submitEditRow() {
      for (const pLang in this.mRequiredLangs) {
        if (!this.OnCheckFormDataInput(pLang)) {
          return;
        }
      }
      // 检查是否格式正确
      for (const pLang in this.mLangsData) {
        if (!this.OnCheckFormDataInput(pLang, true)) {
          return;
        }
      }
      let tTbl = {};
      for (let key in this.mLangKey) {
        for (let serviceKey in this.mFormData) {
          if (this.mLangsData[key] && this.mLangsData[key][serviceKey]) {
            tTbl[serviceKey + this.mLangKey[key]] =
              this.mLangsData[key][serviceKey];
          } else {
            tTbl[serviceKey + this.mLangKey[key]] = "";
          }
        }
      }
      let reqRow = app.clone(this.dialogData.row);
      reqRow.CustomeService = JSON.stringify(tTbl);
      this.dialogData.reqRow = reqRow;
      this.$emit("reqModifyUrl", this.dialogData.reqRow);
    },
    OnChangeUrl(pUrl) {
      if (pUrl.startsWith("@")) {
        return pUrl.replace("@", "https://t.me/");
      }
      return pUrl;
    },
    OnCheckUrl(pUrl, pHeadMsg, pOnlyFormat) {
      pHeadMsg = pHeadMsg || "";
      if (pOnlyFormat && !pUrl) {
        return true;
      }
      if (!pOnlyFormat && !pUrl) {
        this.$message.warning(pHeadMsg + "链接类型的链接地址不能为空");
        return false;
      }
      if (!/^(http|https):\/\/(\S+)$/.test(pUrl)) {
        this.$message.warning(
          pHeadMsg + "链接类型的链接地址需要是http://或https://开头"
        );
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
::v-deep .el-form-item {
  margin-bottom: 0;
}
.el-col-6 {
  padding-bottom: 5px;
}
.red-dot {
  position: absolute;
  top: -1px;
  right: -1px;
}
</style>
